export {
  default,
  getStaticPaths,
  getStaticProps,
} from "app/smartphone/[slug]/[reference]/page";
